import { ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";

export type ClusterDto = ClientInferResponseBody<typeof contract.cluster.findOne>;

export const fetchCluster = async (id: string | undefined): Promise<ClusterDto | null> => {
  if (!id) {
    return null;
  }

  const response = await api.cluster.findOne.query({ params: { id } });

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
